<template>
  <div class="track-trace">
    <div class="track-trace_list list">
      <h2 class="list-title">TRACK & TRACE</h2>
      <div class="list-booking booking">
        <input
          class="booking-input"
          type="text"
          placeholder="Please submit bill, booking, refer number"
        />
        <img
          class="booking-icon"
          src="@/assets/images/icons-wr1/icon-track&trace-w.svg"
          alt=""
        />
      </div>

      <p class="booking-text">
        If you have any questions regarding the results of your shipment
        tracking results, please contact WR1 team. By using the shipment
        tracking service you agree to the terms of use of wr1.com.vn
      </p>
    </div>
    <div class="track-trace_img">
      <img src="@/assets/images/track&trace/track&trace.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "TrackTrace",
};
</script>
<style lang="scss" scoped>
@media (min-width: 990px) {
  .track-trace {
    flex-direction: row !important;
    padding: 20px 70px !important;
    .list {
      .booking {
        &-input {
          width: 58% !important;
        }
        &-icon {
          right: 44% !important;
        }
      }
    }
  }
}
.track-trace {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 80px 30px !important;
  @media (min-width: 1900px) {
    padding: 20px 400px !important;
  }

  justify-content: space-between;
  color: #fff;

  .list {
    max-width: 800px;

    &-title {
      font-weight: 800;
      font-size: 3.2rem;
      line-height: 3.3rem;
      letter-spacing: -0.02em;
      color: #2b938c;
    }
    &-booking {
      position: relative;
      margin: 30px 0;
    }
    .booking {
      &-input {
        width: 100%;

        background: #2b938c;
        border-radius: 40px;
        padding: 15px 60px 15px 25px;
        border: none;
        color: inherit;
        &::placeholder {
          color: #fff;
        }
        &:focus {
          outline: none;
        }
      }
      &-icon {
        position: absolute;
        z-index: 999;
        width: 45px;
        top: 16%;
        right: 3%;
      }
      &-text {
        color: #000;
        font-size: 1.2rem;
        line-height: 2.35rem;
        letter-spacing: -0.02em;
      }
    }
  }
  @media (min-width: 1440px) {
    &_img {
      img {
        max-width: 800px !important;
        height: auto;
      }
    }
  }

  &_img {
    img {
      max-width: 500px;
      width: 100%;
      height: 100%;
    }
  }
}
</style>